<section class="privacy-content container py-4">

  <div class="page-header mt-1">
    <h1 class="fw-bold wrapper-header">Privacy</h1>
  </div>
  <div class="free-content mt-3">
    <p>You may have heard about the UK Data Protection Act, the UK's implementation of (GDPR) which came into force in 2018. It's a pretty big deal, so here at CGP we want to make sure we're looking after our customers' data to the highest level possible.</p>

    <p>Here's the short version: you can be confident that your personal info is secure with us and won't be wandering off anywhere else.</p>

    <p>"I need more detail" we hear you cry.&nbsp;Well, as it happens we have some in-depth Privacy Notices for you to peruse.</p>

    <ul>
      <li>Individual Rights and Privacy Notice — <a class="external-link btn btn-default p-0 cgp-link"
                                                    (click)="externalRedirect.ssoRedirect(`${environment.app.mediaBaseUrl}/getmedia/b1710ba6-57be-456f-b448-ff253dfe9278/Privacy-Notice_May26-002`)">Privacy Notice</a></li>
      <li>Using our online products — <a class="external-link btn btn-default p-0 cgp-link" (click)="externalRedirect.ssoRedirect(`${environment.app.mediaBaseUrl}/getmedia/23bc3fcd-311d-493c-bbe6-68744c62ce77/Childrens-Online-Services-Privacy-Policy_Final`)" target="_blank">Children's&nbsp;Privacy Notice</a></li>
    </ul>

    <p><em>If you have any questions regarding our Privacy Notices or your personal data, please feel free to <a class="external-link btn btn-default p-0 cgp-link" (click)="externalRedirect.ssoRedirect(`${environment.app.mediaBaseUrl}/contact-us`)">get in touch</a>.&nbsp;</em></p>

  </div>

</section>
